// ─────────────────────────────────────────────────────────────
// Brand — OMINA
// One place to change the name/tagline if the identity evolves.
//
// The visual identity: paper ground, midnight ink, petrol depth, one
// hot ember for action. Cool navy + hot orange — the old Warm Paper
// rule ("no true grey, every neutral browned") is retired with the
// palette that needed it; the neutrals are midnight-tinted now.
//
// Type: Cormorant for display, Inter for body and UI (stand-ins for
// the brand book's Canela and Söhne — fonts live ONLY in
// apps/app/src/styles/tokens/typography.css).
//
// BRAND_PALETTE below is the machine-readable record of the four
// anchors. The implementations live in apps/app/src/styles/tokens/
// (the app, as OKLCH ramps + semantic tokens) and apps/web/public/
// index.html (the landing, as hex); the design-guard tests assert
// both stay in sync with this object.
//
// Two rules that are easy to undo by tidying:
//   · Orange is a fill, not an ink — #FF6E42 fails WCAG as text on
//     paper (2.6:1). Filled surfaces carry midnight ink; orange-as-
//     text uses the darker --primary-text token. Measured, enforced
//     by design-contrast.test.ts.
//   · Gold and rust (derived ramps, not in the brand book) exist
//     because three meters and three verification states cannot be
//     told apart with two accent hues. They are semantic, not
//     decorative — see tokens/semantic.css.
// ─────────────────────────────────────────────────────────────

/** The four brand anchors, exactly as the brand book states them.
 *  Pure data (rule: packages/core compiles with `types: []`). */
export const BRAND_PALETTE = {
  paper: "#F9F9F9",
  petrol: "#004E72",
  midnight: "#092634",
  orange: "#FF6E42",
} as const;

export const BRAND = {
  name: "Omina",
  wordmark: "OMINA",
  /** spec §positioning: chief of staff for credibility — never "personal brand" */
  tagline: "Stay in the build.",
  sub: "Your chief of staff for getting known and funded — it turns everything you ship into the words that make investors and customers get it, and only pulls you in to approve.",
  footer: "make your technology legible · articulation, never prediction",
} as const;
/**
 * Shortcuts, not a menu.
 *
 * Shared by the intake and the settings card so one list cannot drift from
 * the other.
 *
 * The field underneath takes any text, and everything downstream — the radar's
 * search, `verticalMatches` — works on whatever she types. These chips exist
 * so the common answers take one tap instead of a sentence; adding one buys
 * speed at intake, never capability.
 *
 * Ordered by how the product is sold: the local-service industries an outsider
 * founder typically sells into come first, then the tech verticals.
 */
export const INDUSTRIES = [
  // Local service — where an industry outsider most often lands.
  "Auto dealers",
  "Real estate",
  "Clinics & health",
  "Dental",
  "Veterinary",
  "Trades & field service",
  "Construction",
  "Restaurants",
  "Hospitality",
  "Legal",
  "Education",
  "Agriculture",
  "Manufacturing",
  "Professional services",
  // Tech verticals.
  "Fintech",
  "Insurance",
  "Logistics",
  "E-commerce",
  "SaaS",
  "Healthtech",
  "Proptech",
];
